import React, { useEffect, useState } from "react"
import KOL from "../../Model/KOL"
import { useSelector } from "react-redux"
import { Trans, useTranslation } from "react-i18next"
import {
  fetchSimilarDataKOLNeo4j,
  fetchSimilarGenreKOLNeo4j,
  searchKOLIdsAlgoliaWithAvatar,
} from "../../HelpingFunction/KOL/kolDBHelper"
import { KOLCombineWithAvatar } from "../../Model/KOLCombine"
import { useHistory } from "react-router-dom"
import AssistantRecommendCard, {
  ASSISTANT_RECOMMEND_CARD_TYPE,
} from "../../Component/AssistantRecommendCard"
import { getUserLang } from "../../Utils/utiltyHelper"
import DivContentLoader from "../../Component/DivContentLoader"

enum SIMILAR_KOL {
  GENRE,
  DATA,
}

const KOLSimilar = () => {
  const history = useHistory()

  const profile: KOL = useSelector((state: any) => {
    return state.KOLInfoManager.kolInfo
  })

  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [kolList, setKOLList] = useState<
    { kol: KOLCombineWithAvatar; type: SIMILAR_KOL }[]
  >([])

  useEffect(() => {
    getSimilarKOLs()
  }, [])

  const getAllKOLData = async (genreKOLs: string[], kolIds: string[]) => {
    const kolListArr: { kol: KOLCombineWithAvatar; type: SIMILAR_KOL }[] = []
    const state = await searchKOLIdsAlgoliaWithAvatar(kolIds)
    if (state.success) {
      state.kols.forEach((k) => {
        if (genreKOLs.includes(k.id)) {
          kolListArr.push({
            kol: k,
            type: SIMILAR_KOL.GENRE,
          })
        } else {
          kolListArr.push({
            kol: k,
            type: SIMILAR_KOL.DATA,
          })
        }
      })
      setKOLList(kolListArr)
      setIsLoaded(true)
    }
  }

  const getSimilarKOLs = async () => {
    const genreResult = await fetchSimilarGenreKOLNeo4j(profile.id)
    const dataResult = await fetchSimilarDataKOLNeo4j(profile.id)

    if (genreResult.success && dataResult.success) {
      getAllKOLData(genreResult.kols, genreResult.kols.concat(dataResult.kols))
    }
  }

  const redirectToProfile = (id: string) => {
    history.push("/" + getUserLang() + "/p/" + id)
  }

  if (isLoaded && kolList) {
    return (
      <div className="w-full md:pt-2 md:p-2 pt-8 md:px-0 px-2">
        <div className="my-4 h-full">
          <h2 className="text-2xl text-left font-medium text-red-default">
            <Trans>SimilarKOL.title</Trans>
          </h2>
          <div className="my-6 p-1">
            <div className="grid xl:grid-cols-3 md:grid-cols-2  sm:grid-cols-1 gap-4 md:px-0 px-1">
              {kolList &&
                kolList.map((k, index) => {
                  return (
                    <AssistantRecommendCard
                      kol={k.kol}
                      type={ASSISTANT_RECOMMEND_CARD_TYPE.NORMAL}
                      canSelectKOL={false}
                      onPreviewKOL={redirectToProfile}
                      badgeTitle={
                        k.type === SIMILAR_KOL.GENRE
                          ? "SimilarKOL.similar-g"
                          : "SimilarKOL.similar-d"
                      }
                      havePriceRange={true}
                    />
                  )
                })}
            </div>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="w-full md:pt-2 md:p-2 pt-8 md:px-0 px-2">
      <div className="my-4 h-full">
        <h2 className="text-2xl text-left font-medium text-red-default">
          <Trans>SimilarKOL.title</Trans>
        </h2>
        <div className="my-6 p-1">
          <div className="grid xl:grid-cols-3  md:grid-cols-2    sm:grid-cols-1 gap-4 md:px-0 px-1 justify-center">
            <DivContentLoader w={270} h={300} r={20} />
            <DivContentLoader w={270} h={300} r={20} />
            <DivContentLoader w={270} h={300} r={20} />
            <DivContentLoader w={270} h={300} r={20} />
            <DivContentLoader w={270} h={300} r={20} />
            <DivContentLoader w={270} h={300} r={20} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default KOLSimilar
